import { OktaAuth } from "@okta/okta-auth-js";

const authClient = new OktaAuth({
  clientId: "0oa5owa8czflOBZyg417",
  issuer: "https://gl-wetteronline.okta.com/oauth2/default",

  tokenManager: {
    expireEarlySeconds: 30,
    autoRenew: true,
  },
});
authClient.start();

export { authClient };
